import { h } from "preact";
import { useLayoutEffect, useRef } from "preact/hooks";
import { useDispatch, useSelector } from "react-redux";
import camelCase from "lodash/camelCase";

import i18n from "../i18n";
import { selectCurrentUserId, toggleChecklistItemOfTask } from "../store";

import Button from "./Button.jsx";
import ChecklistItem from "./ChecklistItem.jsx";
import HeaderIcon from "./HeaderIcon.jsx";
import { sendError } from "../errors";

export default function Checklist(props) {
  const ref = useRef();
  const dispatch = useDispatch();
  const currentUserId = useSelector(selectCurrentUserId);

  async function handleToggle(itemId, value) {
    dispatch(toggleChecklistItemOfTask({ task: props.task, itemId, value }));
  }

  function getItemData(item) {
    return (props.task.data?.data || {})[camelCase(item.id)] || {};
  }

  useLayoutEffect(() => {
    M.AutoInit(ref.current);

    if (props.items.length === 0) {
      sendError(`Empty checklist for task ${props.task.id}`, {
        currentUser: currentUserId,
      });
    }
  }, []);

  return (
    <section class="checklist" ref={ref}>
      <HeaderIcon>{props.icon}</HeaderIcon>
      <h1 class="checklist__headline">
        {i18n.t(`checklist.${props.task.id}.title`)}
      </h1>
      <div class="checklist__items task-page__content">
        {props.items.map((item) => (
          <ChecklistItem
            item={item}
            onToggle={handleToggle}
            data={getItemData(item)}
          />
        ))}
      </div>

      <div class="task-page__buttons">
        <Button secondary onClick={props.onClose}>
          {i18n.t("actions.ok")}
        </Button>
      </div>
    </section>
  );
}
